import React from 'react';
import {
    AppBar,
    Dialog,
    Toolbar,
    IconButton,
    Typography,
    Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { withStyles } from '@mui/styles';

const styles = {
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    imgContainer: {
        position: 'relative',
        flex: 1,
        padding: 16,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    img: {
        maxWidth: '100%',
        maxHeight: '100%',
    },
};

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const ImgDialog = (props) => {
    // const [open, setOpen] = React.useState(false);

    const { classes } = props;

    // const handleClickOpen = () => {
    //     // this.setState({ open: true })
    //     setOpen(true);
    // };

    // const handleClose = () => {
    //     setOpen(false);
    //     // this.setState({ open: false })
    // };

    return (
        <Dialog
            fullScreen
            open={!!props.img}
            onClose={props.onClose}
            TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        onClick={props.onClose}
                        aria-label="Close">
                        <CloseIcon />
                    </IconButton>
                    <Typography
                        variant="title"
                        color="inherit"
                        className={classes.flex}>
                        Cropped image
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.imgContainer}>
                <img
                    src={props.img}
                    alt="Cropped"
                    className={classes.img}
                />
            </div>
        </Dialog>
    );
};

export default withStyles(styles)(ImgDialog);
